import React, { useState } from "react";
import "./CostEstimator.css"; // External CSS

const CostEstimator = () => {
  const [propertyType, setPropertyType] = useState("");
  const [projectType, setProjectType] = useState("");
  const [carpetArea, setCarpetArea] = useState("");
  const [budget, setBudget] = useState(1);
  const [location, setLocation] = useState("");
  const [customFurniture, setCustomFurniture] = useState(false);
  const [selectedFurniture, setSelectedFurniture] = useState("");
  const [estimate, setEstimate] = useState(null);
  const [otherLocation, setOtherLocation] = useState("");

  const propertyOptions = ["Apartment", "Villa", "Office", "Retail Store"];
  const projectOptions = [
    "Full Home Interior",
    "Modular Kitchen",
    "Wardrobe",
    "Workstations",
    "Conference Rooms",
    "Cabins",
    "Outdoor Spaces",
    "Store Setup",
    "Display Units",
  ];
  const furnitureOptions = [
    "Modular Kitchen",
    "Wardrobes",
    "TV Unit",
    "False Ceiling",
    "Wall Paneling",
    "Study Table",
  ];
  const karnatakaDistricts = [
    "Bangalore", "Mysore", "Hubli", "Mangalore", "Belgaum", "Dharwad",
    "Shimoga", "Gulbarga", "Udupi", "Davanagere", "Bellary", "Bijapur", "Other",
  ];

  const handleEstimate = () => {
    if (!propertyType || !projectType || !carpetArea || !location) {
      alert("Please fill in all fields before getting the estimate.");
      return;
    }
    const baseRate = budget === 0 ? 1200 : budget === 1 ? 1800 : 2500;
    const estimatedCost = baseRate * parseFloat(carpetArea);
    setEstimate(estimatedCost);
  };

  return (
    <div className="estimator-container">
      <h2>Interior Cost Estimator</h2>

      {/* Property Type */}
      <label>Property Type:</label>
      <select onChange={(e) => setPropertyType(e.target.value)} value={propertyType}>
        <option value="">Select Property Type</option>
        {propertyOptions.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>

      {/* Project Type */}
      <label>Project Type:</label>
      <select onChange={(e) => setProjectType(e.target.value)} value={projectType}>
        <option value="">Select Project Type</option>
        {projectOptions.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>

      {/* Carpet Area */}
      <label>Carpet Area (sq. ft.):</label>
      <input
        type="number"
        placeholder="Enter area in sq. ft."
        value={carpetArea}
        onChange={(e) => setCarpetArea(e.target.value)}
      />

      {/* Budget Slider */}
      <label>Budget Range:</label>
      <div className="slider-container">
        <input
          type="range"
          min="0"
          max="2"
          step="1"
          value={budget}
          onChange={(e) => setBudget(parseInt(e.target.value))}
        />
        <div className="budget-labels">
          <span className={budget === 0 ? "active" : ""}>Economical</span>
          <span className={budget === 1 ? "active" : ""}>Standard</span>
          <span className={budget === 2 ? "active" : ""}>Luxury</span>
        </div>
      </div>

      {/* Location */}
      <label>Location:</label>
      <select onChange={(e) => setLocation(e.target.value)} value={location}>
        <option value="">Select District</option>
        {karnatakaDistricts.map((dist) => (
          <option key={dist} value={dist}>{dist}</option>
        ))}
      </select>
      {location === "Other" && (
        <input
          type="text"
          placeholder="Enter your location"
          value={otherLocation}
          onChange={(e) => setOtherLocation(e.target.value)}
        />
      )}

      {/* Custom Furniture Checkbox (Hidden for Retail Store) */}
      {propertyType !== "Retail Store" && (
        <>
          <label>
            <input
              type="checkbox"
              checked={customFurniture}
              onChange={() => setCustomFurniture(!customFurniture)}
            />
            Require Customized Furniture?
          </label>
          {customFurniture && (
            <>
              <label>Furniture Type:</label>
              <select
                onChange={(e) => setSelectedFurniture(e.target.value)}
                value={selectedFurniture}
              >
                <option value="">Select Furniture</option>
                {furnitureOptions.map((item) => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            </>
          )}
        </>
      )}

      {/* Get Estimate Button */}
      <button onClick={handleEstimate}>Get Estimate</button>

      {/* Show Estimate */}
      {estimate !== null && (
        <div className="estimate-box">
          <h3>Estimated Cost: ₹{estimate.toLocaleString()}</h3>
        </div>
      )}
    </div>
  );
};

export default CostEstimator;
